export class ApplicationViewConstant {
  static VALUE = 'value'
  static COMMENT = 'comment'
  static NAME = 'name'
  static TIME_PERIOD_VALUE = 'TimePeriodValue'
  static TIME_PERIOD = 'timePeriod'
  static TIME_PERIOD_KEY_VALUE = 'timePeriodKeyValue'
  static TimePeriodKey = 'TimePeriodKey'
}
